import React from "react";
import numberToWord from "../../components/common/utlity/invoiceword";
import {
  SaleformatDateByBusinessPreference,
  truncateCommaSeparatedString,
} from "../../components/common/utlity/utility";
import { useTranslation } from "react-i18next";
import { AWS_URL } from "../../services/http.service";
import { Country, State } from "country-state-city";
const Theme3 = ({
  item,
  containerRef,
  businessName = "Business Name",
  phone = "0000000000",
  bussiness,
  selectedColor,
  darkMode = false,
}) => {
  const { t } = useTranslation();
  if (!item) return <div ref={containerRef}>No invoice data available</div>;

  const businessCountry = bussiness?.country
    ? Country.getCountryByCode(bussiness.country)
    : null;
  const businessState = bussiness?.state
    ? State.getStateByCodeAndCountry(bussiness.state, bussiness.country)
    : null;

  // Country/state for customer
  const customerCountry = item?.country
    ? Country.getCountryByCode(item.country)
    : null;
  const customerState = item?.state
    ? State.getStateByCodeAndCountry(item.state, item.country)
    : null;

  const formatDate = (str) => {
    const date = new Date(str);
    if (!str || isNaN(date)) return str || "-";
    return date.toLocaleDateString();
  };

  // Calculate totals if item.items exists
  const totalQuantity =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + i.quantity, 0) || 0;
  const taxableTotal =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + i.salePrice * i.quantity, 0) || 0;
  const totalTax =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce(
      (sum, i) => sum + (i.salePrice * i.quantity * (i.igst || 0)) / 100,
      0
    ) || 0;
  const totalAmount =
    (item?.invoiceId?.startsWith("RT")
      ? item?.returnitems
      : item?.items
    )?.reduce((sum, i) => sum + (i.finalPrice || 0), 0) || 0;

  const amountInWords = numberToWord(totalAmount || 0);
  const themeStyles = {
  background: "#eff6ff",
  textPrimary: "#000000",
  textSecondary: "#4a5568",
  border: "#000000",
  tableHeader: "#cb39db",
  textColor: "#000000",
};
  return (
    <div
      className="max-w-5xl mx-auto p-6 font-sans text-black text-sm"
      ref={containerRef}
      style={{
        backgroundColor: themeStyles.background,
        color: themeStyles.textColor,
      }}
    >
      {/* Header - Business Name & Phone */}
      <div
        className={`${selectedColor} flex flex-col items-center justify-center gap-1 py-2`}
      >
        <div className="flex items-center justify-center gap-2">
          <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-gray-100 shadow">
            <img
              src={
                bussiness?.businesslogo
                  ? AWS_URL + bussiness.businesslogo
                  : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
              }
              alt="Business Logo"
              className="object-contain w-full h-full"
              //crossOrigin="anonymous"
            />
          </div>
          <div className="font-bold text-lg text-center">{businessName}</div>
        </div>

        <div className="text-center text-xs">
          <span>GSTIN: {bussiness?.gstNumber || "N/A"}</span> <br />
          <span>Email: {bussiness?.email || "N/A"}</span> <br />
          <span>
            {bussiness?.firstLine
              ? `${bussiness.firstLine}, ${businessState?.name || ""}, ${
                  businessCountry?.name || ""
                }`
              : "N/A"}
          </span>
          <br />
          <span>
            {t("NEWINVOICE.PHONE")}: {phone}
          </span>
        </div>
      </div>

      {/* <hr className="border-b-2 border-black" /> */}
      <hr
        className={`border-b-2 ${darkMode ? "border-white" : "border-black"}`}
      />
      <p className="text-center font-bold text-base mb-2">
        {t("NEWINVOICE.TAX_INVOICE")}
      </p>

      {/* Bill To & Invoice Details Header */}
      <div className={`flex ${selectedColor}`}>
        <div className="w-1/2 font-semibold px-3 py-1">
          {t("NEWINVOICE.BILL_TO")}
        </div>
        <div className="w-1/2 text-right font-semibold px-3 py-1">
          {t("NEWINVOICE.INVOICE_DETAILS")}
        </div>
      </div>

      {/* Bill To & Invoice Details */}
      <div className="flex border-t-0">
        <div className="w-1/2 px-3 py-2 text-[10px]">
          <p className="font-bold mb-1">{item.customerName || "-"}</p>
          <p>
            {" "}
            {t("NEWINVOICE.CONTACT_NO")} : {item.mobile || "-"}
          </p>
          <p>
            {t("NEWINVOICE.ADDRESS")}:{" "}
            {item?.address
              ? `${item.address}, ${customerState?.name || ""}, ${
                  customerCountry?.name || ""
                }`
              : "N/A"}
          </p>
        </div>
        <div className="w-1/2 px-3 py-2 text-[10px] text-right">
          <p>
            {t("NEWINVOICE.NO")}: {item.invoiceId || "-"}
          </p>
          {/* <p>Date : {formatDate(item.saleDate)}</p> */}
          <p>
            {t("NEWINVOICE.DATE")}:{" "}
            {SaleformatDateByBusinessPreference(
              item?.saleDate,
              bussiness?.dateFormat
            )}
          </p>
        </div>
      </div>

      {/* Items Table */}
      <table className="w-full mt-4 text-[10px] border-collapse border border-gray-400">
        <thead>
          <tr className={`${selectedColor} font-semibold text-center`}>
            <th className="border border-gray-400 p-1 w-10">#</th>
            <th className="border border-gray-400 p-1 text-left">
              {t("NEWINVOICE.ITEM_NAME")}
            </th>
            <th className="border border-gray-400 p-1 w-20">
              {" "}
              {t("NEWINVOICE.HSN_SAC")}
            </th>
            <th className="border border-gray-400 p-1 w-20">
              {t("NEWINVOICE.QTY")}
            </th>
            <th className="border border-gray-400 p-1 w-32">
              {" "}
              {t("NEWINVOICE.PRICE_PER_UNIT")}
            </th>
            <th className="border border-gray-400 p-1 w-32">
              {t("NEWINVOICE.GST")}
            </th>
            <th className="border border-gray-400 p-1 w-32">
              {" "}
              {t("NEWINVOICE.AMOUNT")}
            </th>
          </tr>
        </thead>
        <tbody>
          {(item?.invoiceId?.startsWith("RT")
            ? item?.returnitems
            : item?.items
          )?.map((itm, idx) => (
            <tr key={idx} className="text-center">
              <td className="border border-gray-400 p-1">{idx + 1}</td>
              <td className="border border-gray-400 p-1 text-left">
                {itm.productName}
              </td>
              <td className="border border-gray-400 p-1">
                {truncateCommaSeparatedString(itm.hsnNumber) || "N/A"}
              </td>
              <td className="border border-gray-400 p-1">{itm.quantity}</td>
              <td className="border border-gray-400 p-1 text-right">
                ₹ {itm.salePrice}
              </td>
              <td className="border border-gray-400 p-1 text-right">
                ₹{" "}
                {(
                  (itm.salePrice * itm.quantity * (itm.igst || 0)) /
                  100
                ).toFixed(3)}{" "}
                ({itm.igst}%){" "}
              </td>
              <td className="border border-gray-400 p-1 text-right">
                ₹ {itm.finalPrice || 0}
              </td>
            </tr>
          ))}

          {/* Total Row */}
          <tr className="text-center font-semibold">
            <td
              colSpan={3}
              className="border border-gray-400 p-1 text-left font-bold"
            >
              {t("NEWINVOICE.TOTAL")}
            </td>
            <td className="border border-gray-400 p-1">{totalQuantity}</td>
            <td className="border border-gray-400" />
            <td className="border border-gray-400 p-1 text-right text-pink-600 font-bold">
              ₹ {totalTax}
            </td>
            <td className="border border-gray-400 p-1 text-right font-bold">
              ₹ {totalAmount}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Bottom Section */}
      <div className="mt-4 flex">
        {/* Left Panel */}
        <div className="w-1/2 flex flex-col">
          <div className={`${selectedColor} font-semibold text-xs p-2`}>
            {t("NEWINVOICE.AMOUNT_IN_WORDS")}
          </div>
          <div className="p-4 text-xs flex-grow capitalize">
            {amountInWords || "Amount in words not available"}
          </div>

          <div
            className={`${selectedColor} font-semibold text-xs p-2 border-t border-gray-400 border-b text-center`}
          >
            {t("NEWINVOICE.PAYMENT_MODE")}
          </div>
          <div className="p-4 text-xs text-center">
            {item.paymentMode || "-"}
          </div>

          {/* Tax Details */}
          <div
            className={`${selectedColor} font-semibold text-xs p-2 border-t border-gray-400 flex border-b-0`}
          >
            <div className="w-1/4 text-center border-r border-gray-400">
              {t("NEWINVOICE.TAX_TYPE")}
            </div>
            <div className="w-1/4 text-center border-r border-gray-400">
              {t("NEWINVOICE.TAXABLE_AMOUNT")}
            </div>
            <div className="w-1/4 text-center border-r border-gray-400">
              {t("NEWINVOICE.RATE")}
            </div>
            <div className="w-1/4 text-center">
              {" "}
              {t("NEWINVOICE.TAX_AMOUNT")}
            </div>
          </div>
          {item.taxGroups?.map((tax, idx) => (
            <div key={idx} className="flex text-xs p-4">
              <div className="w-1/4 text-center border-r border-gray-400">
                {tax.type}
              </div>
              <div className="w-1/4 text-center border-r border-gray-400">
                ₹ {tax.taxableAmount.toFixed(3)}
              </div>
              <div className="w-1/4 text-center border-r border-gray-400">
                {tax.rate}%
              </div>
              <div className="w-1/4 text-center">
                ₹ {tax.taxAmount.toFixed(3)}
              </div>
            </div>
          ))}

          <div
            className={`${selectedColor} font-semibold text-xs p-2 border-t border-gray-400 border-b text-center`}
          >
            {t("NEWINVOICE.TERMS_CONDITIONS")}
          </div>
          <div className="p-4 text-xs text-center">
            {item.termsConditions || t("NEWINVOICE.THANKS_MESSAGE")}
          </div>
        </div>

        {/* Right Panel */}
        <div className="w-1/2 flex flex-col">
          <div
            className={`${selectedColor} font-semibold text-xs p-2 border-b border-gray-400 flex`}
          >
            <div className="w-1/2 text-left">{t("NEWINVOICE.AMOUNT")}</div>
            <div className="w-1/2 text-right">{t("NEWINVOICE.VALUE")}</div>
          </div>

          <div className="flex p-2 border-b border-gray-400 text-xs">
            <div className="w-1/2 font-normal">{t("NEWINVOICE.SUB_TOTAL")}</div>
            <div className="w-1/2 text-right">₹ {taxableTotal.toFixed(3)}</div>
          </div>

          {/* CGST */}
          {item.cgst > 0 && (
            <div className="flex p-2 border-b border-gray-400 text-xs font-normal">
              <div className="w-1/2">{t("TAX_WITHOUT_PERC.CGST")}</div>
              <div className="w-1/2 text-right">₹ {parseFloat(item.cgst).toFixed(2)}</div>
            </div>
          )}

          {/* SGST */}
          {item.sgst > 0 && (
            <div className="flex p-2 border-b border-gray-400 text-xs font-normal">
              <div className="w-1/2">{t("TAX_WITHOUT_PERC.SGST")}</div>
              <div className="w-1/2 text-right">₹ {parseFloat(item.sgst).toFixed(2)}</div>
            </div>
          )}

          {/* IGST */}
          {item.igst > 0 && (
            <div className="flex p-2 border-b border-gray-400 text-xs font-normal">
              <div className="w-1/2">{t("TAX_WITHOUT_PERC.IGST")}</div>
              <div className="w-1/2 text-right">₹ {parseFloat(item.igst).toFixed(2)}</div>
            </div>
          )}

          {/* CESS */}
          {item.cess > 0 && (
            <div className="flex p-2 border-b border-gray-400 text-xs font-normal">
              <div className="w-1/2">{t("TAX_WITHOUT_PERC.CESS")}</div>
              <div className="w-1/2 text-right">₹ {parseFloat(item.cess).toFixed(2)}</div>
            </div>
          )}

          <div className="flex p-2 border-b border-gray-400 text-xs font-bold">
            <div className="w-1/2">{t("NEWINVOICE.TOTAL")}</div>
            <div className="w-1/2 text-right">₹ {totalAmount}</div>
          </div>

          <div className="flex p-2 border-b border-gray-400 text-xs">
            <div className="w-1/2 font-normal">{t("NEWINVOICE.RECEIVED")}</div>
            <div className="w-1/2 text-right">
              ₹ {(item.amountReceived || 0).toFixed(3)}
            </div>
          </div>

          <div className="flex p-2 border-b border-gray-400 text-xs">
            <div className="w-1/2 font-normal">{t("NEWINVOICE.BALANCE")}</div>
            <div className="w-1/2 text-right">
              ₹ {(totalAmount - (item.amountReceived || 0)).toFixed(3)}
            </div>
          </div>

          <div className="p-4 text-center">
            <p className="text-xs mb-2">
              {" "}
              {t("NEWINVOICE.FOR_COMPANY", { company: businessName })}
            </p>
            <p className="font-semibold text-xs">
              {" "}
              {t("NEWINVOICE.AUTHORIZED_SIGNATORY")}
            </p>
          </div>
        </div>
        {bussiness?.aadharPhoto && (
          <div class="flex w-1/2 p-4 bg-gray-100 rounded-lg">
            <img
              src={AWS_URL + bussiness?.aadharPhoto}
              alt="Payment QR Code"
              class="w-30 object-contain"
              //crossOrigin="anonymous"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Theme3;
